/* eslint-disable space-before-function-paren */
/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:16:27
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2019-12-17 20:59:46
 */

// import Conf from './config'

// const service = require('../../assets/js/request')
// const env = process.env

class Common {
  /** 路由管理
   *
   * @static
   * @param {*} option
   * @returns
   * @memberof Common
   */
  static routeManagement(option) {
    var conf = {
      code: 1,
      msg: ''
    }

    let userinfo = localStorage.getItem('token')
    if (!userinfo || userinfo === '') {
      // 是否存在
      if (
        option.to.name &&
        (this.inArray(option.to.name, option.guard.need) > -1 ||
          this.inArray(option.to.name, option.guard.unwante) > -1 ||
          this.inArray(option.to.name, option.guard.public) > -1)
      ) {
        // 没有登录
        if (this.inArray(option.to.name, option.guard.need) > -1) {
          conf.msg = '请先登录'
          conf.code = -1
          alert(conf.msg)
        }
      } else {
        conf.code = 404
        conf.msg = '您访问的页面不存在'
      }
    } else {
      // 是否存在
      if (
        option.to.name &&
        (this.inArray(option.to.name, option.guard.need) > -1 ||
          this.inArray(option.to.name, option.guard.unwante) > -1 ||
          this.inArray(option.to.name, option.guard.public) > -1)
      ) {
        // 已登录
        if (this.inArray(option.to.name, option.guard.unwante) > -1) {
          conf.code = 1
        } else {
          conf.code = 1
          conf.msg = '欢迎回来'
        }
      } else {
        conf.code = 404
        conf.msg = '您访问的页面不存在'
      }
    }
    return conf
  }

  /**
   * 查询数组中的字符
   *
   * @static
   * @param {*} str
   * @param {*} arr
   * @returns
   * @memberof Common
   */
  static inArray(str, arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === str) {
        return i
      }
    }
    return -1
  }

  /**
   * 页面滚动条控制
   *
   * @static
   * @returns
   * @memberof Common
   */
  static scrollstop() {
    var mo = function(e) {
      e.preventDefault()
    }
    document.body.style.overflow = 'hidden'
    document.addEventListener('touchmove', mo, false)
  }

  static scrollmove() {
    var mo = function(e) {
      e.preventDefault()
    }
    document.body.style.overflow = ''
    document.removeEventListener('touchmove', mo, false)
  }
  // 判断图片是否能进行正常访问
  static imgIsOnload(path) {
    const env = process.env
    path = env.IMG_URL + path
    return new Promise(function(resolve, reject) {
      Common.imgIsError(path)
        .then(() => {
          resolve(path)
        })
        .catch(() => {
          var oldPath = path.replace('compress-', '')
          Common.imgIsError(oldPath)
            .then(() => {
              resolve(oldPath)
            })
            .catch(() => {
              reject(new Error(''))
            })
        })
    })
  }

  static imgIsError(path) {
    var img = new Image()
    img.src = path

    return new Promise(function(resolve, reject) {
      img.onload = function() {
        resolve()
      }
      img.onerror = function() {
        reject(new Error(''))
      }
    })
  }
}

export default Common



// WEBPACK FOOTER //
// ./src/assets/js/common.js